import React, { useState, useEffect } from 'react'

const CyberSecurity = () => {
    const [activeService, setActiveService] = useState('security-assessment');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">PROTECT YOUR DIGITAL ASSETS</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    Cyber <span className="breadcrumb-highlight">Security</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Cyber Security Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Advanced Cyber Security </span> Solutions & Services
                                </h2>
                                <p className="ai-driven-description">
                                    In an era of sophisticated cyber threats, CLOUD MIND X provides comprehensive security solutions to protect your critical assets, data, and infrastructure. Our certified security experts deliver proactive threat detection, vulnerability management, incident response, and compliance services. We employ cutting-edge technologies and proven methodologies to safeguard your organization against evolving cyber risks across all attack vectors.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO SECURITY EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80"
                                    alt="Cyber Security Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR SECURITY EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With certified security professionals holding CISSP, CEH, CISM credentials,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> delivers enterprise-grade cybersecurity services that protect<br />
                                    organizations from data breaches, ransomware, and cyber attacks worldwide.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="security-assessment">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Security Assessment & Audit</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="penetration-testing">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Penetration Testing</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="security-operations">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Security Operations Center (SOC)</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="incident-response">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Incident Response & Forensics</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="compliance-management">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Compliance Management</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="security-awareness">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Security Awareness Training</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* Security Assessment */}
                                <div className="service-detail active" id="security-assessment">
                                    <h3 className="service-detail-title">Security Assessment & Audit</h3>
                                    <p className="service-detail-description">
                                        Identify vulnerabilities and security gaps with comprehensive assessments covering networks, applications, cloud infrastructure, and endpoints. Our security audits evaluate current security posture against industry standards and best practices. We provide detailed findings, risk ratings, and prioritized remediation recommendations to strengthen your security defenses.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Security Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Penetration Testing */}
                                <div className="service-detail" id="penetration-testing">
                                    <h3 className="service-detail-title">Penetration Testing</h3>
                                    <p className="service-detail-description">
                                        Simulate real-world cyber attacks to uncover security weaknesses before malicious actors do. Our ethical hackers conduct thorough penetration tests on web applications, mobile apps, networks, and infrastructure using industry-standard methodologies (OWASP, PTES). We provide actionable insights and proof-of-concept exploits to validate and remediate vulnerabilities.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Penetration Test</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Security Operations */}
                                <div className="service-detail" id="security-operations">
                                    <h3 className="service-detail-title">Security Operations Center (SOC)</h3>
                                    <p className="service-detail-description">
                                        Maintain 24/7 security monitoring and threat detection with our managed SOC services. We deploy advanced SIEM platforms, threat intelligence feeds, and automated response systems to detect and respond to security incidents in real-time. Our SOC analysts continuously monitor your environment, investigating alerts and coordinating incident response efforts.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request SOC Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Incident Response */}
                                <div className="service-detail" id="incident-response">
                                    <h3 className="service-detail-title">Incident Response & Digital Forensics</h3>
                                    <p className="service-detail-description">
                                        Respond swiftly to security breaches with our expert incident response team. We contain threats, preserve evidence, conduct forensic analysis, and restore operations while minimizing damage. Our digital forensics capabilities identify attack vectors, determine scope of compromise, and support legal proceedings with detailed documentation and chain-of-custody procedures.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Incident Response</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Compliance Management */}
                                <div className="service-detail" id="compliance-management">
                                    <h3 className="service-detail-title">Compliance Management</h3>
                                    <p className="service-detail-description">
                                        Achieve and maintain compliance with regulatory requirements including GDPR, HIPAA, PCI-DSS, SOC 2, ISO 27001, and NIST frameworks. We conduct gap assessments, implement necessary controls, develop policies and procedures, and prepare for audits. Our compliance management ensures you meet legal obligations while maintaining robust security practices.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Compliance Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Security Awareness */}
                                <div className="service-detail" id="security-awareness">
                                    <h3 className="service-detail-title">Security Awareness Training</h3>
                                    <p className="service-detail-description">
                                        Build a security-conscious culture with comprehensive training programs for employees. We deliver engaging security awareness training covering phishing, social engineering, password security, data protection, and safe computing practices. Our training includes simulated phishing campaigns and metrics tracking to measure effectiveness and reduce human-related security risks.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Training Program</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Security Technologies Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">SECURITY TECHNOLOGIES</span>
                                <h2 className="section-title-dark">Cyber Security Solutions & Technologies</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X deploys enterprise-grade security technologies and best-in-class solutions to protect organizations. Our security expertise covers <strong>network security, application security, cloud security, and endpoint protection</strong> across healthcare, financial services, retail, government, manufacturing, and technology sectors worldwide.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Network Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L36 14V22C36 29 30 35 24 40C18 35 12 29 12 22V14L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M20 24L22 26L28 20" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Network Security</h4>
                                <p className="capability-description">
                                    Deploy comprehensive network security solutions including next-generation firewalls, intrusion detection/prevention systems (IDS/IPS), DDoS protection, VPN, and network segmentation. Our network security architecture protects against unauthorized access, malware propagation, and data exfiltration while ensuring optimal network performance and availability.
                                </p>
                            </div>
                        </div>

                        {/* Application Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="12" y="10" width="24" height="28" rx="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 18H30M18 22H26M18 26H30M18 30H24" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M24 8L28 10L24 12L20 10L24 8Z" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Application Security</h4>
                                <p className="capability-description">
                                    Secure applications throughout the development lifecycle with SAST, DAST, and SCA tools. We implement secure coding practices, conduct code reviews, perform vulnerability scanning, and integrate security testing into CI/CD pipelines. Our AppSec approach ensures applications are protected against OWASP Top 10 vulnerabilities and emerging threats.
                                </p>
                            </div>
                        </div>

                        {/* Cloud Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 20C10 20 8 23 8 26C8 29 10 32 14 32H34C37 32 40 29 40 26C40 23 38 20 34 20C34 16 31 12 26 12C21 12 18 15 18 19C16 19 14 20 14 20Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 22L26 24L24 26L22 24L24 22Z" fill="#4187f7" />
                                        <circle cx="24" cy="24" r="2" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Cloud Security</h4>
                                <p className="capability-description">
                                    Implement comprehensive cloud security measures including identity and access management (IAM), encryption, CSPM, CWPP, and CASB solutions. We secure cloud workloads, containers, serverless functions, and SaaS applications across AWS, Azure, and GCP. Our cloud security ensures data protection, compliance, and threat prevention in cloud environments.
                                </p>
                            </div>
                        </div>

                        {/* Endpoint Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="14" y="10" width="20" height="28" rx="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 8L36 14L30 24L24 20L18 24L12 14L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" opacity="0.3" />
                                        <circle cx="24" cy="22" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="32" r="1.5" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Endpoint Protection</h4>
                                <p className="capability-description">
                                    Protect endpoints with advanced EPP and EDR solutions featuring antivirus, anti-malware, behavioral analysis, and threat hunting capabilities. We secure desktops, laptops, mobile devices, and IoT endpoints against ransomware, zero-day exploits, and advanced persistent threats. Our endpoint security includes device management and policy enforcement.
                                </p>
                            </div>
                        </div>

                        {/* Identity & Access Management */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="18" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 38C12 32 16 28 24 28C32 28 36 32 36 38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="18" r="3" fill="#4187f7" opacity="0.3" />
                                        <path d="M30 34H18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Identity & Access Management</h4>
                                <p className="capability-description">
                                    Implement robust IAM solutions with multi-factor authentication (MFA), single sign-on (SSO), privileged access management (PAM), and identity governance. We enforce least-privilege access, automate user provisioning/de-provisioning, and monitor access activities. Our IAM solutions prevent unauthorized access and ensure compliance with security policies.
                                </p>
                            </div>
                        </div>

                        {/* Threat Intelligence */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="8" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" />
                                        <path d="M24 10V6M24 42V38M10 24H6M42 24H38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Threat Intelligence & Hunting</h4>
                                <p className="capability-description">
                                    Leverage threat intelligence feeds and proactive threat hunting to identify emerging threats before they impact your organization. We analyze threat actor tactics, techniques, and procedures (TTPs), correlate indicators of compromise (IOCs), and conduct threat hunting campaigns. Our intelligence-driven approach enhances detection and response capabilities.
                                </p>
                            </div>
                        </div>

                        {/* Data Protection */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="14" y="12" width="20" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M20 12V10C20 8 21 6 24 6C27 6 28 8 28 10V12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="24" r="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 24V28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Data Loss Prevention (DLP)</h4>
                                <p className="capability-description">
                                    Prevent sensitive data leakage with comprehensive DLP solutions that monitor, detect, and block unauthorized data transfers. We implement data classification, encryption, content inspection, and policy enforcement across endpoints, networks, and cloud services. Our DLP strategies protect intellectual property, customer data, and regulated information.
                                </p>
                            </div>
                        </div>

                        {/* Security Analytics */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="28" width="6" height="12" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="17" y="20" width="6" height="20" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="26" y="14" width="6" height="26" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="35" y="22" width="6" height="18" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="11" cy="26" r="2" fill="#4187f7" />
                                        <circle cx="20" cy="18" r="2" fill="#4187f7" />
                                        <circle cx="29" cy="12" r="2" fill="#4187f7" />
                                        <circle cx="38" cy="20" r="2" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Security Analytics & SIEM</h4>
                                <p className="capability-description">
                                    Deploy advanced SIEM platforms with machine learning and behavioral analytics to detect anomalies and security incidents. We aggregate and correlate logs from diverse sources, create custom detection rules, and generate actionable alerts. Our security analytics provide comprehensive visibility into security posture and accelerate incident detection and response.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CyberSecurity
